import games from 'video/games.mp4';

const ListVideo = [games];

export {ListVideo};
